import { jsonToXlsx } from '@/utils/xlsExport/jsonToXlsx';
import staticData from './staticData';
import { pickOrderObj } from '@/utils/functions';
import i18n from '@/plugins/i18n';
import { formatFloat } from '@/utils/functions';
import moment from 'moment';

export const exportXls = (data) => {
  const cols = staticData(true).columns;
  jsonToXlsx({
    name: `${i18n.t('Lotto report')} - ${moment().format('DD-MM-YYYY HH:mm')}`,
    headers: cols.map((c) => c.label),
    data: data.map((item) => {
      item.entry_value = formatFloat(item?.entry_value);
      item.turnover = formatFloat(item?.turnover);
      item.bonus = formatFloat(item?.bonus);
      item.payout = formatFloat(item?.payout);

      return pickOrderObj(
        item,
        cols.map((c) => c.key)
      );
    })
  });
};

// Group games and sum turnover, bonus, payout
export const groupedGames = (data) => {
  let gamesGrouped = [];
  let idGames = [];

  // list of unique id games
  idGames = Array.from(new Set(data.map((item) => item.gameId)));

  // for each idGame sum and push in returned list
  for (const id of idGames) {
    let gameData = data.filter((d) => d.gameId == id);
    let total = {
      turnover: 0,
      payout: 0,
      bonus: 0
    };

    for (const game of gameData) {
      total.turnover += parseFloat(game?.turnover || 0);
      total.payout += parseFloat(game?.payout || 0);
      total.bonus += parseFloat(game?.bonus || 0);
    }

    gamesGrouped.push({
      ...gameData[0],
      ...total
    });
  }

  return gamesGrouped.sort(function (a, b) {
    let keyA = a.gameName;
    let keyB = b.gameName;
    if (keyA < keyB) return -1;
    if (keyA > keyB) return 1;
    return 0;
  });
};

export default {
  groupBy(data, groupBy) {
    let groupedData = [];

    if (groupBy === 'product_type') {
      let productTypes = Array.from(new Set(data.map((item) => item.product_type_name)));

      for (const product_type_name of productTypes) {
        let productItems = data.filter((item) => item.product_type_name === product_type_name);

        let productItem = {
          ...productItems[0],
          turnover: 0,
          payout: 0,
          bonus: 0,
          entry_value: 0,
          data: []
        };

        for (const item of productItems) {
          productItem.turnover += parseFloat(item.turnover);
          productItem.payout += parseFloat(item.payout);
          productItem.bonus += parseFloat(item.bonus);
          productItem.entry_value += parseFloat(item.entry_value);

          if (item.data) {
            productItem.data = [...productItem.data, ...item.data];
          }
        }

        groupedData.push(productItem);
      }
    } else {
      groupedData = data;
    }

    return groupedData;
  }
};
